import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  items: [],
  tvodItems: [],
  location: "",
  loading: true,
  error: null,
  couponStatus: "",
  couponToken: "",
  couponLoading: false,
  couponMessage: "",
};
const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    getResponse(state, action) {
      state.loading = true;
      state.couponStatus = "";
      state.error = null;
    },
    fetchResponseSuccess(state, action) {
      state.items = action.payload;
      state.loading = false;
    },
    getResponseByCountry(state, action) {
      state.loading = true;
      state.couponStatus = "";
      state.error = null;
    },
    fetchResponseSuccessByCountry(state, action) {
      state.items = action.payload;
      state.loading = false;
    },
    getResponseByPackageType(state, action) {
      state.loading = true;
      state.couponStatus = "";
      state.error = null;
    },
    fetchResponseSuccessByPackageType(state, action) {
      state.items = action.payload;
      state.loading = false;
    },
    getResponseByCoupon(state, action) {
      state.couponLoading = true;
      state.couponStatus = "";
      state.couponMessage = "";
      state.error = null;
    },
    fetchResponseSuccessByCoupon(state, action) {
      state.error = null;
      state.couponLoading = false;
      if (action.payload?.status) {
        state.couponStatus = "true";
        state.couponMessage = action.payload?.message || "";
        state.couponToken = action.payload?.token || "";
      } else {
        state.couponStatus = "false";
        state.couponMessage = action.payload?.message || "Invalid coupon code";
      }
    },
    getTvodResponseByCountry(state, action) {
      state.loading = true;
      state.couponStatus = "";
      state.error = null;
    },
    getTvodResponseSuccessByCountry(state, action) {
      state.tvodItems = action.payload;
      state.loading = false;
    },
    getLocation(state, action) {
      state.loading = true;
    },
    getLocationSuccess(state, action) {
      state.location = action.payload;
      state.loading = false;
    },
    onFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    onCouponFailure(state, action) {
      state.error = action.payload;
      state.couponLoading = false;
      state.couponStatus = "false";
      state.couponMessage =
        action.payload || "Something went wrong. Please try again.";
    },
  },
});
export const {
  getResponse,
  fetchResponseSuccess,
  getResponseByCountry,
  fetchResponseSuccessByCountry,
  getResponseByPackageType,
  fetchResponseSuccessByPackageType,
  getResponseByCoupon,
  fetchResponseSuccessByCoupon,
  getTvodResponseByCountry,
  getTvodResponseSuccessByCountry,
  getLocation,
  getLocationSuccess,
  onFailure,
  onCouponFailure,
} = paymentSlice.actions;
export default paymentSlice.reducer;
